<ul class="list-none grid grid-cols-2 gap-1 max-w-96 mb-2 select-none">
  <ef-validation-check [status]="passwordPartsValidation().upperCase">{{
    'password-check-upper-case' | translate
  }}</ef-validation-check>
  <ef-validation-check [status]="passwordPartsValidation().lowerCase">{{
    'password-check-lower-case' | translate
  }}</ef-validation-check>
  <ef-validation-check [status]="passwordPartsValidation().minLength">{{
    'password-check-min-length' | translate
  }}</ef-validation-check>
  <ef-validation-check [status]="passwordPartsValidation().digitOrSpecial">{{
    'password-check-digit-or-special' | translate
  }}</ef-validation-check>
</ul>
